module.exports = __webpack_public_path__ + "img/full1-min.1fabbb64.png";